import React from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import objectPath from "object-path";
import { FiTrash2, FiPlus } from "react-icons/fi";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import Dropzone from "../../../Components/Dropzone";
import { api } from "../../../Services/Api";
import { setProductDialogState } from "../../../Store/Modules/Dialogs/Actions";

import { Context } from "../ProductContext";
import {
  Container,
  Form,
  ProductImageContainer,
  CenterBlock,
  Actions,
} from "./style";

export default function ProductInfo() {
  const reduxDispatch = useDispatch();
  const { productState, dispatch, saveProduct } = React.useContext(Context);
  const [selectedFile, setSelectedFile] = React.useState();
  const [savingImage, setSavingImage] = React.useState(false);
  const [removingImage, setRemovingImage] = React.useState(false);

  React.useEffect(() => {
    if (selectedFile) {
      const data = new FormData();
      data.append(
        "image",
        selectedFile,
        `${productState.printDescription}.png`
      );
      setSavingImage(true);
      api
        .put(`menu/products/${productState._id}/image`, data)
        .then(({ data }) => {
          dispatch({ type: "REPLACE_IMAGE", url: data.url });
        })
        .catch((err) => toast.error("Erro ao salvar imagem"))
        .finally(() => setSavingImage(false));
    }
  }, [selectedFile]);

  function handleRemoveImage() {
    setRemovingImage(true);
    api
      .delete(`menu/products/${productState._id}/image`)
      .then(() => {
        dispatch({ type: "REPLACE_IMAGE", url: "" });
      })
      .catch((err) => toast.error("Erro ao remover imagem"))
      .finally(() => setRemovingImage(false));
  }

  function handleSubmit(event) {
    event.preventDefault();
    saveProduct();
  }

  function handleInputChange(event) {
    const { value, name } = event.target;
    const updatedProduct = { ...productState };
    objectPath.set(updatedProduct, name, value);
    dispatch({ type: "REPLACE", product: updatedProduct });
  }

  function handleInputCurrencyhange(event, value) {
    const { name } = event.target;
    const updatedProduct = { ...productState };
    objectPath.set(updatedProduct, name, value);
    dispatch({ type: "REPLACE", product: updatedProduct });
  }

  return (
    <Container>
      <ProductImageContainer>
        {!removingImage && (
          <Dropzone
            initialUrl={productState.picture || ""}
            fileChange={setSelectedFile}
          />
        )}
        {savingImage && (
          <CenterBlock>
            <p>Salvando Imagem...</p>
          </CenterBlock>
        )}
        {removingImage && (
          <CenterBlock>
            <p>Removendo imagem Imagem...</p>
          </CenterBlock>
        )}
        {productState.picture && !removingImage && (
          <CenterBlock
            onClick={handleRemoveImage}
            style={{ cursor: "pointer" }}
          >
            <FiTrash2 style={{ fontSize: "24px", color: "red" }} />
          </CenterBlock>
        )}
      </ProductImageContainer>
      <Form onSubmit={handleSubmit}>
        <TextField
          value={productState.printDescription}
          onChange={handleInputChange}
          id="printDescription"
          type="text"
          name="printDescription"
          variant="outlined"
          label="Descrição do produto"
          autoComplete="off"
          InputLabelProps={{
            shrink: true,
          }}
          fullWidth
        />

        <TextField
          autoComplete="off"
          onChange={handleInputChange}
          value={productState.details}
          id="details"
          name="details"
          multiline
          label="Detalhes do produto"
          rows={3}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          fullWidth
        />

        <CurrencyTextField
          id="price"
          onChange={handleInputCurrencyhange}
          value={productState.price}
          label="Preço"
          name="price"
          style={{ width: "100px" }}
          variant="outlined"
          placeholder="0"
          currencySymbol="R$"
          required
          minimumValue="0"
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
        />
        <hr />
        <Actions>
          <Button type="submit" color="primary" variant="contained">
            Salvar
          </Button>
          <Button
            size="small"
            color="default"
            onClick={() => reduxDispatch(setProductDialogState("activeTab", 1))}
          >
            Adicionais
          </Button>
          {/* <Button size='small' color='default'>
            <FiPlus style={{ marginRight: '5px' }} />
            Novo produto
          </Button>
          <Button size='small' color='default'>
            <FaRegClone style={{ marginRight: '5px' }} />
            Duplicar
          </Button> */}
        </Actions>
      </Form>
    </Container>
  );
}
